export const DEFAULT_PUBLIC_SURVEY_LOGO_URL =
  "https://www.feradel.com/wp-content/uploads/2025/02/Logox100h.png";

